<div *ngIf="itensMenu" class="ml-1 d-none d-lg-block">
  <div *ngFor="let item of itensMenu" class="list-group">
    <div class="menu-filtro">
      <a
        (click)="buscaMateriais(item)"
        class="panel-heading collapsed {{ menuAtivo ? '' : 'disabled' }}"
      >
        {{ item.titulo }}
      </a>
    </div>
  </div>
</div>
